import { observable, computed, action } from "mobx";
import { asyncAction } from "mobx-utils";
import Autobind from "autobind-decorator";
import PanelControlModel from "pages/demo-dashboard/modules/model/panelControlModel";
import RootStore from "./rootStore";
/**
 * @class WorklistStore
 * @description 요청에 따른 Study 목록을 반환
 */
@Autobind
class PanelControlStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용

  @observable
  panelControl = new PanelControlModel();

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  @action
  getAllPanelDisableState() {
    return this.panelControl.disabledMap;
  }

  @action
  setAllPanelDisableState(disabled: any) {
    this.panelControl.controlPanelDisable = disabled;
    this.panelControl.analysisPanelDisable = disabled;
    this.panelControl.opacityPanelDisable = disabled;
    this.panelControl.measurementPanelDisable = disabled;
    this.panelControl.exportPanelDisable = disabled;
  }

  @action
  getControlPanelDisable() {
    return this.panelControl.controlPanelDisable;
  }

  @action
  setControlPanelDisable(isDisabled: any) {
    this.panelControl.controlPanelDisable = isDisabled;
  }

  @action
  getAnalysisPanelDisable() {
    return this.panelControl.analysisPanelDisable;
  }

  @action
  setAnalysisPanelDisable(isDisabled: any) {
    this.panelControl.analysisPanelDisable = isDisabled;
  }

  @action
  getOpacityPanelDisable() {
    return this.panelControl.opacityPanelDisable;
  }

  @action
  setOpacityPanelDisable(isDisabled: any) {
    this.panelControl.opacityPanelDisable = isDisabled;
  }

  @action
  getMeasurementPanelDisable() {
    return this.panelControl.measurementPanelDisable;
  }

  @action
  setMeasurementPanelDisable(isDisabled: any) {
    this.panelControl.measurementPanelDisable = isDisabled;
  }

  @action
  getExportPanelDisable() {
    return this.panelControl.exportPanelDisable;
  }

  @action
  setExportPanelDisable(isDisabled: any) {
    this.panelControl.exportPanelDisable = isDisabled;
  }
}

export default PanelControlStore;
